











































import { Vue, Component, Prop } from 'vue-property-decorator'
import FlexTooltip from '@/components/FlexTooltip.vue'
import ViewerModal from '../components/ViewerModal.vue'
import moment from 'moment'
import { TaskGradeController } from '@/services/request.service'
import { i18n } from '@/i18n/i18n'
import { toPage } from '@/utils/utils'
import { createPagination } from '@/constant/constant'

@Component({
  components: {
    FlexTooltip,
    ViewerModal,
  },
})
export default class ScoreLevel extends Vue {
  private data: any = []
  private viewerInfo: any = {
    name: '',
    sections: [],
    items: [],
    taskGradeLevelId: -1,
  }
  private viewerType: any = 'view'
  private viewerVisible: boolean = false
  private gradingData: any = {}
  private loading: boolean = false
  private moment = moment
  private pagination: any = createPagination({
    showTotal: total => i18n.tc('common.pageTotal', total, { total }),
  })
  private env = process.env.VUE_APP_ENV || ''

  private get columns(): Array<any> {
    return [
      {
        dataIndex: 'name',
        key: 'name',
        title: this.$t('common.name'),
        scopedSlots: { customRender: 'name' },
        ellipsis: 'true',
      },
      {
        dataIndex: 'sections',
        title: this.$t('common.grade'),
        scopedSlots: { customRender: 'sections' },
      },
      {
        dataIndex: 'modifyTime',
        key: 'updateTime',
        title: this.$t('setup.grading.updateTime'),
        scopedSlots: { customRender: 'updateTime' },
      },
      {
        key: 'operations',
        title: this.$t('common.operations'),
        scopedSlots: { customRender: 'operations' },
      },
    ]
  }

  private created() {
    this.getData()
  }

  private viewGrade(record): void {
    this.viewerType = 'view'
    this.viewerInfo = record
    this.viewerVisible = true
  }

  private add(): void {
    this.viewerVisible = true
    this.viewerType = 'add'
    this.viewerInfo = {}
  }

  private getData(page = { current: 1, pageSize: this.pagination.defaultPageSize }): void {
    this.loading = true
    this.data = []
    TaskGradeController.getTaskGradeLevels(page.current, page.pageSize)
      .then(res => {
        this.data = res.data.items
        this.pagination.total = res.data.totalItem
        this.pagination.current = page.current
        toPage(page, this.data, page => {
          this.pagination.current = page
          this.refresh()
        })
      })
      .catch(err => console.error(err))
      .finally(() => (this.loading = false))
  }

  private edit(record): void {
    this.viewerVisible = true
    this.viewerType = 'edit'
    this.viewerInfo = record
  }

  private handleTableChange(pagination): void {
    this.pagination.current = pagination.current
    this.pagination.pageSize = pagination.pageSize
    this.getData(pagination)
  }

  private refresh(): void {
    this.getData(this.pagination)
  }
}
